import type { CaptainBillingHistoryFilters } from "../types";

const normalizedClientId = (clientId: string) => clientId.toLowerCase();

export const captainBillingKeys = {
  all: ["captain-billing"] as const,
  byClient: (clientId: string) => [...captainBillingKeys.all, normalizedClientId(clientId)] as const,
  account: (clientId: string) => [...captainBillingKeys.byClient(clientId), "account"] as const,
  histories: (clientId: string) => [...captainBillingKeys.byClient(clientId), "history"] as const,
  history: (clientId: string, filters: CaptainBillingHistoryFilters) =>
    [...captainBillingKeys.histories(clientId), filters] as const,
  usages: (clientId: string) => [...captainBillingKeys.byClient(clientId), "usage"] as const,
  usage: (clientId: string, months: number) => [...captainBillingKeys.usages(clientId), months] as const,
};
